import Visibility from '@mui/icons-material/Visibility';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function VisibilityIcon(props: FixMe) {
  return <Visibility {...props} />;
}

export default VisibilityIcon;
